module.exports = __webpack_public_path__ + "img/yijian_zhhongji.fa59712a.png";